import { TenantSettingsRepository } from "../../../domain/tenant-settings-repository";
import { HttpService } from "../../http/http";
import { Injectable } from "@angular/core";
import { TenantSettings } from "../../../domain/tenant-settings";
import { ContentControlAIObjectDetectionSettings } from '../../../domain/content-control/ai-settings';
import {
  ICommonUtilInterface
} from "../../../domain/common/common-util.interface";
import {
  AIVideoAnalyzeConfig,
  IAIObjectDetectionClass
} from '../../../domain/content-control/ai';

@Injectable()
export class CachedTenantSettingsRepositoryImpl
  implements TenantSettingsRepository
{
  constructor(
    private httpService: HttpService,
    private _commonUtils: ICommonUtilInterface
  ) {}

  cachedTenantSettings: TenantSettings = null;

  init() {
    return this.httpService
      .get("Tenant/GetTenantSettings")

      .then((tenantSettings:TenantSettings) => {

/*        tenantSettings.ContentControlAIdetectionsSettings = [];
        const detectionClass = <IAIObjectDetectionClass>{
          class_name: 'Test',
          config: AIVideoAnalyzeConfig.DEFAULT()
        };
        tenantSettings.ContentControlAIdetectionsSettings.push(new ContentControlAIObjectDetectionSettings(this._commonUtils.generateGuid(), "object_detection", detectionClass));
*/
        this.cachedTenantSettings = tenantSettings;
        this.postCacheSetActions();
        return this.cachedTenantSettings;
      });
  }
  postCacheSetActions(): void {
    localStorage.setItem(
      "calendar.fdoww",
      this.cachedTenantSettings.FirstDayOfWorkWeek.toString(),
    );
  }
  getTenantSettings(): Promise<TenantSettings> {
    return Promise.resolve(this.cachedTenantSettings);
  }
  setTenantSettings(settings: TenantSettings): Promise<boolean> {
    return this.httpService
      .post("Tenant/UpdateTenantSettings", {
        AllowDeleteOfOriginalMedia: settings.DeleteOriginalMediaFiles,
        DoQcAnalizeWhenUploading: settings.DoQcAnalizeWhenUploading,
        AllowRecordingFeature: settings.AllowRecordingFeature,
        PreviewChannelsLimit: settings.PreviewChannelsLimit,
        UseMediaStartTimestampInScheduler:
          settings.UseMediaStartTimestampInScheduler,
        TranscodingAvailabilityZoneId: settings.TranscodingAvailabilityZoneId,
        LiveFeedWebRTCPreviewAvailabilityZoneId:
          settings.LivePreviewAvailabilityZoneId,
        LongShowColorHex: settings.LongShowColorHex,
        LongShowSeconds: settings.LongShowSeconds,
        UseTranscodeBypassFeature: settings.TranscodeBypassFeatureEnabled,
        NextShowSkipTagIds: settings.NextShowSkipTagIds,
        ShowMediaLicenseSettings: settings.ShowMediaLicenseSettings,
        ContentControlTranscodingProfileId:
          settings.ContentControlTranscodingProfileId,
        ContentControlTranscodingDestinationId:
          settings.ContentControlTranscodingDestinationId,
        ClippingStudioTranscodingDestinationId:
          settings.ClippingStudioTranscodingDestinationId,
        ContentControlAIDetectionsSettings:
          settings.ContentControlAIdetectionsSettings,
        DisplayContentControlStudioTimeInFrames:
          settings.DisplayContentControlStudioTimeInFrames,
        FirstDayOfWorkWeek: settings.FirstDayOfWorkWeek,
        QCWorkflowObjectives: settings.QCWorkflowObjectives,
        ByPassWithGeneratingLowRes: settings.ByPassWithGeneratingLowRes,
        BroadcastsPreviewChannelStaticRendererSuffix: settings.BroadcastsPreviewChannelStaticRendererSuffix,
        BroadcastsProgramChannelStaticRendererSuffix: settings.BroadcastsProgramChannelStaticRendererSuffix
      })
      .then((result) => {
        if (result) {
          this.cachedTenantSettings = settings;
          this.postCacheSetActions();
        }

        return result;
      });
  }
}
